module.exports = __webpack_public_path__ + "static/img/huawei-appgallery-badge-es.583972a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huawei-appgallery-badge-es.png
// module id = Oar2
// module chunks = 1